/**
 * This file is part of the Haiman.
 * @link     : https://haiman.io/
 * @author   : Emil Zhai (root@derzh.com)
 * @modifier : Emil Zhai (root@derzh.com)
 * @copyright: Copyright (c) 2018 Hangzhou Haila Network Technology Co., Ltd.
 */

import http from './driver';
import { TonesStart, UserTone } from './types/tones';

/* 音鉴开始信息 */
export const getTonesStart = () => http.get<TonesStart>('user/tones/start');
/* 申请音鉴鉴定 */
export const getTonesAcquire = (errcodeExpected) => http.get('user/tones/acquire', { errcodeExpected });
/* 获取朗读材料 */
export const getTonesMaterial = () => http.get<TonesStart>('user/tones/material');
/* 列出音色信息 */
export const getUserTones = (scene, point, limit) => http.get<UserTone[]>('user/tones', { scene, point, limit });
/* 提交音色鉴定 */
export const postUserTones = (body) => http.post('user/tones', body);
/* 查看音色详情 */
export const getUserTonesDetail = (id) => http.get<UserTone>(`user/tones/detail-${id}`);
/* 坚定音色 */
export const putUserTonesDetail = (id, main, secondary) => http.put(`user/tones/detail-${id}`, { main, secondary });
